import { footprint, footprintV2, collect } from '../server';

const userCirculation = (obj: any) => {
  for (const y in obj) {
    if (true) {
      if (obj[y] === '' || obj[y] === null || obj[y] === undefined) {
        delete obj[y];
      }
    }
  }
  return obj;
};

export async function userRecord(moduleIndex?: any, deed?: any, relationId?: any) {
  const obj: any = {
    module_index: moduleIndex ? moduleIndex : '',
    deed: deed ? deed : '',
    relation_id: relationId ? relationId : '',
    series: moduleIndex ? moduleIndex : ''
  };
  const res = await footprint(userCirculation(obj));
  // const resObj = await collect(userCirculation(obj));
  const resObj = await collect(obj);
  console.log(res);
  console.log(resObj);
}

export async function userRecordV2(moduleIndex?: any, deed?: any, relationId?: any) {
  const obj: any = {
    module_index: moduleIndex ? moduleIndex : '',
    deed: deed ? deed : '',
    relation_id: relationId ? relationId : '',
    series: moduleIndex ? moduleIndex : ''
  };
  const res = await footprintV2(userCirculation(obj));
  // const resObj = await collect(userCirculation(obj));
  const resObj = await collect(obj);
  console.log(res);
  console.log(resObj);
}
